export const stringsKey = "LanguageSelection";
export const englishStrings = {
	selectLanguageLabel: "Select Language",
	languageRequiredErrorMessage: "The language field is required.",
};
